/**
 * The surface the Auto-plan dialog paints, rather than the theme's own background.
 *
 * Anything that has to match it - the fade at the foot of each column, the sticky summary the task list
 * scrolls under - reads it from here, so the surface and the things blending into it cannot drift apart.
 *
 * On a soft background it is that background's own off-white (Petr, 2026-10-10), not the cool #FAFBFD.
 */
export const dialogBackground = (theme: any) =>
  theme.name === 'light' ? theme.dialogSurface ?? '#FAFBFD' : theme.backgroundDark;
